import { render, staticRenderFns } from "./LinkWithApisOrders.vue?vue&type=template&id=ce95472e&scoped=true&"
import script from "./LinkWithApisOrders.vue?vue&type=script&lang=js&"
export * from "./LinkWithApisOrders.vue?vue&type=script&lang=js&"
import style0 from "./LinkWithApisOrders.vue?vue&type=style&index=0&id=ce95472e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce95472e",
  null
  
)

export default component.exports